import { EPayoutType } from "@rentiohq/shared-frontend/dist/types/payment.types";
import {
  EPaymentRequestFeature,
  EPaymentRequestStatus,
  IPaymentRequest,
} from "@rentiohq/shared-frontend/dist/types/paymentRequest.types";
import { formatDate } from "@rentiohq/shared-frontend/dist/utils/date.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";

// A charge the API has already claimed for an automatic SEPA collection: the
// same "pending + PLANNED_PAY_IN" rule rentio-api-next uses for an in-flight
// collection (paymentRequest.repo getPlannedPayInQueryBuilder), limited to the
// tenant's own charges. The tenant has nothing left to do for it, and paying
// it manually as well would collect it twice.
// Once the serverless planned-in worker hands the pay-in to MangoPay it swaps
// PLANNED_PAY_IN for PLANNED_PAYED_IN, and the request stays pending until
// MangoPay settles it. That collection is still on its way, so both count.
const PLANNED_COLLECTION_FEATURES = [
  EPaymentRequestFeature.PlannedPayIn,
  EPaymentRequestFeature.PlannedPayedIn,
];

export const PLANNED_COLLECTION_FILTER = {
  status: { eq: EPaymentRequestStatus.Pending },
  payoutType: { eq: EPayoutType.Charge },
  // The v2 WhereBuilder puts this `or` in its own brackets and ANDs it with
  // the two fields above, also when the whole filter sits inside another `or`.
  or: PLANNED_COLLECTION_FEATURES.map(feature => ({
    features: { like: `%${feature}%` },
  })),
};

export const isPlannedCollection = ({
  status,
  payoutType,
  features,
}: Pick<IPaymentRequest, "status" | "payoutType" | "features">) =>
  status === EPaymentRequestStatus.Pending &&
  payoutType === EPayoutType.Charge &&
  PLANNED_COLLECTION_FEATURES.some(feature =>
    (features ?? []).includes(feature),
  );

// Same date and wording the broker follow-up shows for a pending collection
// (utils/payment.ts getFollowUpReason).
export const getPlannedCollectionMessage = ({
  estimatedCollectionDate,
  dueDateAt,
}: Pick<IPaymentRequest, "estimatedCollectionDate" | "dueDateAt">) =>
  getLocalizedText("payments.follow_up.reason.pending.with_collection_date", {
    date: formatDate(estimatedCollectionDate ?? dueDateAt),
  });
